module.exports = __webpack_public_path__ + "img/background.a58ab439.jpg";